export { ComponentModel, ComponentModelProps } from './component-model';
